var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19173_2696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3753 5.46273H11.6253V3.12939H3.45866C2.81699 3.12939 2.29199 3.65439 2.29199 4.29606V10.7127H3.45866C3.45866 11.6811 4.24033 12.4627 5.20866 12.4627C6.17699 12.4627 6.95866 11.6811 6.95866 10.7127H10.4587C10.4587 11.6811 11.2403 12.4627 12.2087 12.4627C13.177 12.4627 13.9587 11.6811 13.9587 10.7127H15.1253V7.79606L13.3753 5.46273ZM5.20866 11.5877C4.72449 11.5877 4.33366 11.1969 4.33366 10.7127C4.33366 10.2286 4.72449 9.83773 5.20866 9.83773C5.69283 9.83773 6.08366 10.2286 6.08366 10.7127C6.08366 11.1969 5.69283 11.5877 5.20866 11.5877ZM13.0837 6.33773L14.227 7.79606H11.6253V6.33773H13.0837ZM12.2087 11.5877C11.7245 11.5877 11.3337 11.1969 11.3337 10.7127C11.3337 10.2286 11.7245 9.83773 12.2087 9.83773C12.6928 9.83773 13.0837 10.2286 13.0837 10.7127C13.0837 11.1969 12.6928 11.5877 12.2087 11.5877Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19173_2696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.895508 0.881104)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogistics);
export default __webpack_public_path__ + "static/media/logistics.2b2979e005d43dc672afbdd5dc833b91.svg";
export { ForwardRef as ReactComponent };